import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: max-content;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  padding: ", ";\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  transition: opacity 200ms;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import MediaQuery from 'react-responsive';
import styled, { css } from '../utils/styling/styled-components';
import { theme } from '../theme';
import { TooltipArrow } from './TooltipArrow';
import { TooltipStyle } from './types';
import { tooltipStylesMap } from './utils';
var Overlay = styled.div(_templateObject(), function (props) {
  return props.tooltipStyles.backgroundColor;
}, function (props) {
  return props.tooltipStyles.color;
}, function (props) {
  return props.tooltipStyles.padding;
}, function (props) {
  return props.visible && "\n    opacity: 1;\n    pointer-events: auto;\n  ";
}); // TODO: width: max-content is required due to quirks mode, remove when ready.

var ContentContainer = styled.div(_templateObject2(), function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth && "\n      max-width: ".concat(maxWidth, "px;\n    ");
});
var TriggerWrapper = styled.span(_templateObject3(), function (props) {
  return props.containerWidth && css(_templateObject4(), props.containerWidth);
});

var TooltipComponent = function TooltipComponent(_ref2) {
  var _ref2$arrow = _ref2.arrow,
      arrow = _ref2$arrow === void 0 ? true : _ref2$arrow,
      children = _ref2.children,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? 'top' : _ref2$placement,
      visibleOverride = _ref2.visibleOverride,
      defaultVisible = _ref2.defaultVisible,
      className = _ref2.className,
      _ref2$trigger = _ref2.trigger,
      trigger = _ref2$trigger === void 0 ? 'hover' : _ref2$trigger,
      content = _ref2.content,
      _ref2$tooltipStyle = _ref2.tooltipStyle,
      tooltipStyle = _ref2$tooltipStyle === void 0 ? TooltipStyle.Default : _ref2$tooltipStyle,
      maxWidth = _ref2.maxWidth,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
      testId = _ref2.testId,
      containerWidth = _ref2.containerWidth,
      _ref2$closeOnOutsideC = _ref2.closeOnOutsideClick,
      closeOnOutsideClick = _ref2$closeOnOutsideC === void 0 ? true : _ref2$closeOnOutsideC,
      onVisibleChange = _ref2.onVisibleChange,
      _ref2$gutter = _ref2.gutter,
      gutter = _ref2$gutter === void 0 ? 9 : _ref2$gutter;
  var tooltipStyles = tooltipStylesMap[tooltipStyle];
  var options = {
    defaultVisible: defaultVisible || visibleOverride,
    placement: placement,
    trigger: trigger,
    offset: [offset, gutter],
    closeOnOutsideClick: closeOnOutsideClick,
    onVisibleChange: onVisibleChange
  };

  if (visibleOverride !== undefined) {
    options.visible = visibleOverride;
  }

  var _usePopperTooltip = usePopperTooltip(options),
      getTooltipProps = _usePopperTooltip.getTooltipProps,
      getArrowProps = _usePopperTooltip.getArrowProps,
      setTooltipRef = _usePopperTooltip.setTooltipRef,
      setTriggerRef = _usePopperTooltip.setTriggerRef,
      visible = _usePopperTooltip.visible;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TriggerWrapper, {
    ref: setTriggerRef,
    containerWidth: containerWidth
  }, children), /*#__PURE__*/React.createElement(Overlay, _extends({
    visible: visible,
    className: className,
    ref: setTooltipRef,
    tooltipStyles: tooltipStyles
  }, getTooltipProps()), arrow && /*#__PURE__*/React.createElement(TooltipArrow, {
    arrowColor: tooltipStyles.backgroundColor,
    getArrowProps: getArrowProps,
    placement: placement
  }), /*#__PURE__*/React.createElement(ContentContainer, {
    "data-testid": testId,
    maxWidth: maxWidth
  }, content)));
};

export var TooltipV2 = function TooltipV2(_ref3) {
  var _ref3$mobileOverrides = _ref3.mobileOverrides,
      mobileOverrides = _ref3$mobileOverrides === void 0 ? {} : _ref3$mobileOverrides,
      children = _ref3.children,
      baseProps = _objectWithoutProperties(_ref3, ["mobileOverrides", "children"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, function (matches) {
    var props = baseProps;

    if (matches) {
      props = _objectSpread(_objectSpread({}, baseProps), mobileOverrides);
      return /*#__PURE__*/React.createElement(TooltipComponent, props, children);
    }

    return /*#__PURE__*/React.createElement(TooltipComponent, props, children);
  }));
};